import type { CoreSiteConfigQuery } from '~/graphql/generated/graphql';

export interface AppTypeHeaders {
  'phoenix-app-type': string;
}

export const COUNTRY_CODE_ALPHA_2 = <const>{
  AU: 'au',
  US: 'us',
};

export type CountryCodeAlpha2 = (typeof COUNTRY_CODE_ALPHA_2)[keyof typeof COUNTRY_CODE_ALPHA_2];

export interface ExternalToolsConfig {
  brazeAppGroupId: string;
  mixpanelProfileBaseUrl: string;
}

export interface UseClusterCountryConfig {
  clusterCountry: CoreSiteConfigQuery['core']['site']['publicSiteConfig']['country'];
  clusterCountryCodeAlpha2: ComputedRef<CountryCodeAlpha2>;
  clusterTimezone: ComputedRef<string>;
  isUsa: boolean;
  isAus: boolean;
  externalToolsConfig: ExternalToolsConfig;
}
